import { render, staticRenderFns } from "./DkOneStepLeadFormModal.vue?vue&type=template&id=0ec0f52b&"
import script from "./DkOneStepLeadFormModal.vue?vue&type=script&lang=js&"
export * from "./DkOneStepLeadFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports